import { useState, useEffect } from 'react'
import { Button, Card, Col, Modal, Row } from 'react-bootstrap'
import React from 'react'
import { Schema, Form, InputPicker, Uploader } from 'rsuite';
import RedStar from '../../../../Shared/GenericComponents/RedStar';
import GenericAttachmentGrid from '../../../../Shared/Grid/GenericAttachmentGrid';
import { getBoardMembers } from '../../../../../services/Shared/codeTable.service';
import boardApprovalService from '../../../../../services/Internal/Application/PLS/boardApproval.service';
import attachmentService from '../../../../../services/Shared/attachment.service';
import Swal from 'sweetalert2';
import BlockUi from '@availity/block-ui';
import TextArea from '../../../../Shared/GenericComponents/TextArea';


function BoardApprovalModal(props) {

    const { ObjectType, DateType } = Schema.Types;
    const [blockUi, setBlockUi] = useState(false);
    const model = Schema.Model({
        dateSent: DateType().isRequired('This field is required.'),
        boardMember: ObjectType().isRequired('This field is required.'),
    })
    const decisionData = [
        { "label": "Approved", "value": { id: 1, boardMemberDecision: "Approved" } },
        { "label": "Declined", "value": { id: 2, boardMemberDecision: "Declined" } }];

    const [boardMemebers, setBoardMembers] = useState([])
    const [approvalModel, setApprovalModel] = useState()
    useEffect(() => {
        setApprovalModel(props.modalData);
        getBoardMembers().then(setBoardMembers);
    }, [props.modalData])

    const formSubmit = (validation, event) => {
        if (validation) {
            setBlockUi(true);
            var formData = new FormData()
            var dataToTransmit = {
                ...approvalModel,
                dateSent: new Date(approvalModel.dateSent).toISOString(),
                dateReceived: approvalModel.dateReceived ? new Date(approvalModel.dateReceived).toISOString() : null
            }
            formDataAppender('boardMemberResponse', dataToTransmit, formData);
            for (var i = 0; i < approvalModel.files.length; i++) {
                formData.append('files', approvalModel.files[i].blobFile);
            }
            boardApprovalService.postBoardResponse(formData).then((response) => {
                setBlockUi(false);
                if (response.data.boardMemberResponse.id) {
                    props.updateGrid();
                    props.onHide();
                }

            })
        }

    }
    const formDataAppender = (passedKey, model, formData) => {
        for (let key in model) {
            if (typeof (model[key]) === 'object') {
                formDataAppender(`${passedKey}.${key}`, model[key], formData); // Recursive key for objects
            }
            else {
                if (passedKey)
                    formData.append(`${passedKey}.${key}`, model[key]);
                else
                    formData.append(`${key}`, model[key]);
            }
        }
    }
    const handleChange = (val, e) => {
        if (!e.entries().next().done) {
            var newFiles = approvalModel.files;
            newFiles.push(val);
            setApprovalModel({ ...approvalModel, files: [...newFiles] })
        }
    };
    const deleteFile = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setApprovalModel({ ...approvalModel, files: approvalModel.files.filter(x => x.fileKey != id) })
            }
        })
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <BlockUi blocking={blockUi}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Board/Staff Member Response
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form model={model} id="boardForm" formValue={approvalModel} onChange={approvalModel => setApprovalModel(approvalModel)} onSubmit={formSubmit} fluid>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Form.ControlLabel>
                                    <strong>
                                        Date Sent&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Row>
                            <Row>
                                <Form.Control name="dateSent" block type="date" />
                            </Row>
                        </Form.Group>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Form.ControlLabel>
                                    <strong>
                                        Board/Staff Member&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Row>
                            <Row>
                                <Form.Control
                                    block
                                    name="boardMember"
                                    placeholder="Pick Board Member"
                                    accepter={InputPicker}
                                    data={boardMemebers} />
                            </Row>
                        </Form.Group>
                        <hr />
                        <Form.Group className='mx-3'>
                            <Row>
                                <Form.ControlLabel>
                                    <strong>
                                        Date Received
                                </strong>

                                </Form.ControlLabel>
                            </Row>
                            <Row>
                                <Form.Control name="dateReceived" block type="date" />
                            </Row>
                        </Form.Group>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Form.ControlLabel>
                                    <strong>
                                        Decision
                                </strong>
                                </Form.ControlLabel>
                            </Row>
                            <Row>
                                <Form.Control
                                    block
                                    name="boardMemberDecision"
                                    placeholder="Choose..."
                                    accepter={InputPicker}
                                    data={decisionData} />
                            </Row>
                        </Form.Group>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Col sm="12">
                                    <strong>File Upload&nbsp;</strong>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Form.Control
                                        accepter={Uploader}
                                        listType="text"
                                        onUpload={handleChange}
                                        fileListVisible={false}
                                        multiple
                                        draggable
                                        accept={attachmentService.ATTACHMENTTYPES}>
                                        <div style={{ width: '100%', lineHeight: '150px' }}>Click or Drag files to this area to upload</div>
                                    </Form.Control>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    {approvalModel?.files?.length > 0 &&
                                        <div>
                                            <br />
                                            <Form.Control
                                                accepter={GenericAttachmentGrid}
                                                deleteFileCallback={deleteFile}
                                                data={approvalModel.files.map((value, i) => {
                                                    return {
                                                        id: value.fileKey,
                                                        timestamp: new Date().toLocaleDateString(),
                                                        file: value.blobFile?.name
                                                    }
                                                })}
                                                isSync={true}
                                                tStyle="table-bordered"
                                                name="filesForDisplay" />
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Form.ControlLabel>
                                    <strong>
                                        Comments
                                </strong>
                                </Form.ControlLabel>
                            </Row>
                            <Row>
                                <Form.Control name="comments" accepter={TextArea} rows={4} />
                            </Row>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" form="boardForm" variant="primary">Submit</Button>
                    <Button variant="danger" onClick={props.onHide}>Cancel</Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
    );
}

export default BoardApprovalModal;